export const getPropertiesPopup = ({ title, geolocation, imageurl, link }) => `
  <div class="image">
    <img src="${imageurl}" alt="bg-image" />
  </div>
  <div class="details">
    <div class="details-title">
      <span  class="sd-body1">${title},</span>
      <span  class="sd-body2">${geolocation}</span>
    </div>
    <a class="sd-button--primary" href="${link}">Discover</a>
  </div>
`;
